import React from "react";
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export default ({ isLoading, text, loadingText, disabled = false, circularProgressProps,  ...props }) =>
	<Button color={props.color || 'primary'} disabled={disabled || isLoading} {...props}>
		{isLoading && <CircularProgress {...circularProgressProps} />}
		{!isLoading ? text : loadingText}
	</Button>;